import React, { useState } from "react";
import "./AppointmentSection.css";
import appointmentMobile from "./../../Images/phone-appointment.png";
import appointmentSchedule from "./../../Images/appointment-scheduled.png";
import bookAppointment from "./../../Images/book-appointment.png";
import WhatsappIcon from "./../../Images/whatsapp.png";
import { useNavigate } from "react-router-dom";
import EnquirePopup from "../EnquirePopup";

const fronturl = process.env.REACT_APP_FRONTEND_URL;

const AppointmentSection = () => {
  const navigate = useNavigate(null);
  const [showPopup, setShowPopup] = useState(false);


  const handlePopup = () => {
    setShowPopup(true);
  };
  
  const closePopup = () => {
    setShowPopup(false);
  };
  return (
    <div className="appointment-sec">
      <div className="container">
        <div className="row align-center">
          <div className="col-md-12 col-lg-5 second-text">
            <h2>Scheduled Appointments in few seconds</h2>
            <h5>
            The Businessbay virtual card has features such as calendar integration, which makes it easy to schedule an appointment.
            <br />
            Professionalism at its finest.
            </h5>
            <a style={{ cursor: "pointer" }} 
            onClick={handlePopup}
            className="green-button">
              {/* <img src={WhatsappIcon} style={{width:"36px", height:"36px"}}/> */}
              Tap to Get Yours
            </a>
            {/* <div
              style={{ cursor: "pointer" }}
              // onClick={() => navigate("/register")}
              // onClick={() => window.location.href = `${fronturl}register`}
              onClick={() => window.open(`${fronturl}register`, '_blank')}
              className="yellow-button"
            >
              Book Your Slot
            </div> */}
          </div>
          <div className="col-md-12 col-lg-7 relative2">
            <img src={appointmentMobile} />
            <div className="appointment-schedule">
              {" "}
              <img src={appointmentSchedule} />{" "}
            </div>
            <div className="book-appointment">
              {" "}
              <img src={bookAppointment} />
            </div>
          </div>
        </div>
        {showPopup && (
               <EnquirePopup  open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
              )}
      </div>
    </div>
  );
};

export default AppointmentSection;
